import React, { useState, useCallback, useMemo, memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import classes from "./ConditionalTooltipText.scss";

const styles = {
  tooltipWidth: {
    maxWidth: "40rem",
  },
};

const ConditionalTooltipText = ({ text, className, overlayInnerStyle }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const checkIfTextOverflow = useCallback(node => {
    if (node) {
      if (node.offsetWidth < node?.scrollWidth) {
        setShowTooltip(true);
      } else {
        setShowTooltip(false);
      }
    }
  }, []);

  const tooltipStyles = useMemo(
    () => ({
      ...styles.tooltipWidth,
      ...overlayInnerStyle,
    }),
    [overlayInnerStyle]
  );

  const textClassName = useMemo(
    () => classNames(className, classes.customText),
    [className]
  );

  const tooltipWrapper = useMemo(
    () => (
      <Tooltip overlayInnerStyle={tooltipStyles} tooltip={text} showArrow />
    ),
    [tooltipStyles, text]
  );

  return (
    <ConditionalWrapper
      wrapper={tooltipWrapper}
      condition={showTooltip}
      type="wrapperAsElement"
    >
      <div ref={checkIfTextOverflow} className={textClassName}>
        {text}
      </div>
    </ConditionalWrapper>
  );
};

ConditionalTooltipText.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  overlayInnerStyle: PropTypes.object,
};

ConditionalTooltipText.defaultProps = {
  className: "",
  overlayInnerStyle: {},
};

export default memo(ConditionalTooltipText);
